export default function (x) {
  return function () {
    return x;
  };
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/_d3-interpolate@1.3.3@d3-interpolate/src/constant.js
// module id = 402
// module chunks = 0